import { render, staticRenderFns } from "./horizontalSlidePage.vue?vue&type=template&id=2813a5ec"
import script from "./horizontalSlidePage.vue?vue&type=script&lang=ts"
export * from "./horizontalSlidePage.vue?vue&type=script&lang=ts"
import style0 from "./horizontalSlidePage.vue?vue&type=style&index=0&id=2813a5ec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports